<template>
  <v-card
    :class="enableButtons ? 'container-card' : 'grey-card container-card'"
    elevation="1"
  >
    <div class="md-light batch-name">
      {{ batchName }}
    </div>
    <v-card-title>
      <div class="md-subheader-no-spacing">{{ report.reportName }}</div>
      <v-tooltip v-if="!enableButtons" location="left" class="disabled-tooltip">
        <template v-slot:activator="{ props }">
          <v-btn icon variant="plain" color="white" v-bind="props">
            <v-icon icon="lock" />
          </v-btn>
        </template>
        <span>
          {{ disabledMessage }}
        </span>
      </v-tooltip>
    </v-card-title>

    <v-card-text>
      <div class="md-list-no-spacing">{{ report.reportDescription }}</div>
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-col cols="12" sm="6">
        <v-btn
          variant="flat"
          @click="$emit('btnClick', 'web', report)"
          data-testid="report-card-web"
          :disabled="!enableButtons"
          class="report-button"
        >
          WEB
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" v-if="showPdfBtn">
        <v-btn
          variant="flat"
          @click="$emit('btnClick', 'pdf', report)"
          data-testid="report-card-pdf"
          :disabled="!enableButtons"
          class="report-button"
        >
          PDF
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn
          v-if="showCsvBtn"
          variant="flat"
          @click="$emit('btnClick', 'csv', report)"
          data-testid="report-card-csv"
          :disabled="!enableButtons"
          class="report-button"
        >
          CSV
        </v-btn>
        <v-btn
          v-else
          variant="flat"
          @click="$emit('btnClick', 'xlsx', report)"
          data-testid="report-card-xlsx"
          :disabled="!enableButtons"
          class="report-button"
        >
          Excel
        </v-btn>
      </v-col>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
    showPdfBtn: {
      type: Boolean,
      default: true,
    },
    showCsvBtn: {
      type: Boolean,
      default: true,
    },
    enableButtons: {
      type: Boolean,
      default: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
    completedReports: {
      type: Array,
      required: false,
    },
    batchName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
  computed: {
    image() {
      return require(`@/assets/${this.report.reportIcon}`);
    },

    disabledMessage() {
      if (
        this.completedReports &&
        this.completedReports.includes(this.report.reportName) &&
        !this.campaign.complete
      ) {
        return "Please complete your store to enable this report";
      } else {
        return "This report is not available for your store";
      }
    },
  },
};
</script>

<style scoped>
.report-img {
  align-items: center;
  justify-content: center;
  padding-left: 15px !important;
}
.report-card {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  height: 100%;
  width: 100%;
  align-items: center;
}
/* .report-card p {
  height: 72px;
  max-height: 72px;
} */
.report-description {
  font-size: 12px;
}
.report-btn {
  font-size: 12px;
  font-weight: 500;
  /* padding: 5px 10px; */
  background-color: #e4e4e4;
  border-radius: 2px;
  height: 25px;
  /* max-width: 40px; */
  margin-right: 10px;
}
.btn-group {
  align-items: center;
  justify-content: center;
}
.report-content {
  padding-left: 25px !important;
}
.grey-card {
  opacity: 0.4;
}

.report-button {
  width: 100%;
}

.container-card {
  height: 100%;
  width: 100%;
}

.disabled-tooltip {
  position: absolute;
  top: 6px;
  right: 10px;
}

.batch-name {
  position: relative;
  top: 16px;
  padding-left: 16px;
  color: var(--tf-accent-crimson);
}
</style>

